import { ShowSnackbarModel } from "../../commons/scaffold/scaffold";

export default class WebRedirectFormState {
    isLoading: boolean = false;
    errorSnackbar?: ShowSnackbarModel;
    webViewLink?: string;
    customId: string = "";
    redirectUrl: string = "";
}